import wrapInTabContentContainer from '../../../AppNavigator/TabNavigation/wrapInTabContentContainer';
import AddNoteScreen from './AddNoteScreen';
import NoteDetailsScreen from './NoteDetailsScreen';
import NoteEditScreen from './NoteEditScreen';
import NotesRootScreen from './NotesRootScreen';
import NoteTransferScreen from './NoteTransferScreen';
import SendNoteScreen from './SendNoteScreen';

const screens = {
    AddNoteScreen: wrapInTabContentContainer(AddNoteScreen),
    NoteDetailsScreen: wrapInTabContentContainer(NoteDetailsScreen),
    NoteEditScreen: wrapInTabContentContainer(NoteEditScreen),
    NotesRootScreen: wrapInTabContentContainer(NotesRootScreen),
    NoteTransferScreen: wrapInTabContentContainer(NoteTransferScreen),
    SendNoteScreen: wrapInTabContentContainer(SendNoteScreen),
};

export { screens };
